// Kept apart from trashApi.js, with no imports, because the sidebar needs
// TRASH_FEATURES — and pulling axios into the sidebar breaks its tests (CRA's
// Jest can't parse axios's ES module build).

/**
 * What can be in the trash, in tab order. `feature` is the permission each is
 * granted under — the same map the server uses (TRASH_TYPES in trashService).
 */
export const TRASH_TYPES = [
  { type: "book", label: "Books", one: "book", feature: "books" },
  { type: "summary", label: "Summaries", one: "summary", feature: "summaries" },
  { type: "author", label: "Authors", one: "author", feature: "authors" },
  { type: "series", label: "Series", one: "series", feature: "series" },
  { type: "recommender", label: "Recommenders", one: "recommender", feature: "recommenders" },
  { type: "recommenderRow", label: "Recommender rows", one: "recommender row", feature: "recommenders" },
  { type: "post", label: "Posts", one: "post", feature: "posts" },
  { type: "collection", label: "Journeys", one: "journey", feature: "collections" },
];

export const TYPE_INFO = Object.fromEntries(TRASH_TYPES.map((t) => [t.type, t]));

/** Every feature a trashable type is granted under — who gets the nav row. */
export const TRASH_FEATURES = [...new Set(TRASH_TYPES.map((t) => t.feature))];
